let gHistory = null;

export function initialize(history) {
  gHistory = history;
}

export { gHistory as default };
